"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @name getCookieLevel
 *
 * @param {String} name the name of the cookie to get the level for
 * @param {Object} [options] key value list of cookies to their level.  keys can also be regex (as string) - which will match the first one it finds.caches
 *
 * @returns {Integer} 0, 1, or 2 if found.  undefined if not found.
 */
var _default = exports.default = function _default(name, levels) {
  if (name in levels) {
    return levels[name];
  }
  return levels[Object.keys(levels).find(function (key) {
    if (key.match(/^\/.*\/$/)) {
      var rx = new RegExp(key.slice(1, -1));
      if (rx.test && rx.test(name)) {
        return levels[key];
      }
    }
    return false;
  })];
};